import React, { Component } from 'react';
import '../../components/css/popupstyle.css';
import $ from 'jquery';
import loader from '../../components/css/dark/img/loader.gif';
import exportIcon from '../../components/css/dark/img/theme-images/export.svg';

class ReportPopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userdata: JSON.parse(localStorage.getItem('user')),
            ActiveJson: this.props.ActiveRepList,
            InActiveJson: this.props.InactiveRepList,
            header: this.props.text,
            error: '',
            APICalled: false,
            noDataDisplay: ''
        };       
        this.handletab = this.handletab.bind(this.handletab);
        this.ExportReps = this.ExportReps.bind(this);
    }

    handletab(e) {
        try {
            let dataId = $(e.target).attr('data-id');            
            if (dataId == 1) {
                $('.tab2').hide();
                $('.tab1').show();
                $('.link2').removeClass('active');
                $('.link1').addClass('active');
            } else {
                $('.tab1').hide();
                $('.tab2').show();
                $('.link1').removeClass('active');
                $('.link2').addClass('active');
            }
            setTimeout(function () {
                // add class on scroll condition
                (function ($) {
                    $.fn.hasScrollBar = function () {
                        return this.get(0).scrollHeight > this.height();
                    }
                })($);
                if ($('.max-height').hasScrollBar()) {
                    $('.table-container').addClass('active-scroll');
                } else {
                    $('.table-container').removeClass('active-scroll');
                }
            }, 2000);
        }
        catch (error) {
            this.setState({ error: 'Something went wrong. Please try later.'});
        }
    }
    GetRepsDetailwithoutAPI() {
        try {
            let UserName = "";
            //if (this.state.userdata.wholesaler == "Avenel") {
            //    UserName = this.state.userdata.email;
            //}
            //else if (this.state.userdata.wholesaler != "Avenel") {
            //    UserName = this.state.userdata.paramsname;
            //}
            //else {
                UserName = this.state.userdata.paramsname;
            //}
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    'roleName': UserName, 'roleType': this.state.userdata.wholesaler, 'wholesaler_Id': this.state.userdata.wholesaler_Id, 'distributor_UserId': this.state.userdata.distributor_UserId })
            };
            return fetch(`/api/ds/repsNew`, requestOptions)
                .then(this.handleResponse)
                //fetch('https://cnd.23byt.es/ds/reps?sname=' + UserName)
                .then(response => response.json())
                .then(data => {
                    setTimeout(() => {
                        $('.popup').addClass('mfp-ready');
                        $('.popup').addClass('mfp-bg');
                        $('.popup').addClass('mfp-with-anim');
                    }, 5);
                    let userEmail = this.state.userdata.email;
                    this.setState({ APICalled: true });
                    if (data != null && data.length > 0) {
                        try {
                            data.forEach((item) => {
                                if (item.emailId.toLowerCase() == userEmail.toLowerCase()) {
                                    this.setState({ ActiveJson: JSON.parse(item.activeJson), noDataDisplay: 'Reps not available', InActiveJson: JSON.parse(item.inActiveJson), iscalled: true });
                                }
                            });


                        } catch (error) {
                            this.setState({ iscalled: false });
                        }


                        var rowsShown = 6;
                        var maxnoshow = 4;

                        // first tab
                        var rowsTotal = this.state.ActiveJson.length;
                        var numPages = rowsTotal / rowsShown;
                        for (var i = 0; i < numPages; i++) {
                            var pageNum = i + 1;
                            $('.tab1 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
                            $('.tab1 select').append('<option val="' + i + '">' + pageNum + '</option> ');
                        }
                        $('#inactive_reps > div.flex-table').hide();
                        $('#inactive_reps > div.flex-table').slice(0, rowsShown).show();

                        // second tab
                        var rowsTotal2 = this.state.InActiveJson.length;
                        var numPages2 = rowsTotal2 / rowsShown;
                        for (var i = 0; i < numPages2; i++) {
                            var pageNum = i + 1;
                            $('.tab2 .nav_in').append('<a href="javascript:;" rel="' + i + '">' + pageNum + '</a> ');
                            $('.tab2 select').append('<option val="' + i + '">' + pageNum + '</option> ');
                        }
                        $('#inactive_reps2 .flex-table').hide();
                        $('#inactive_reps2 .flex-table').slice(0, rowsShown).show();

                        $('.tab1 .nav_in a:first').addClass('active');
                        $('.tab2 .nav_in a:first').addClass('active');
                        $('.tab1 .nav_in a').hide();
                        $('.tab2 .nav_in a').hide();
                        $('.tab1 .nav_in a').slice(0, maxnoshow).show();
                        $('.tab2 .nav_in a').slice(0, maxnoshow).show();
                        $('.tab1 .nav_in a').bind('click', function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab1 .nav_in a').removeClass('active');
                            $(this).addClass('active');
                            var currPage = $(this).attr('rel');
                            var startItem = currPage * rowsShown;
                            var endItem = startItem + rowsShown;
                            $('#inactive_reps .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
                            if ($(this).attr('rel') != '0') {
                                $('.tab1 .nav_in a').hide();
                                $(this).prev().show();
                                $(this).show()
                                $(this).next().show();
                                $(this).next().next().show();
                            }
                        });
                        $('.tab2 .nav_in a').bind('click', function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab2 .nav_in a').removeClass('active');
                            $(this).addClass('active');
                            var currPage = $(this).attr('rel');
                            var startItem = currPage * rowsShown;
                            var endItem = startItem + rowsShown;
                            $('#inactive_reps2 .flex-table').css('opacity', '0.0').hide().slice(startItem, endItem).css('display', 'flex').animate({ opacity: 1 }, 300);
                            if ($(this).attr('rel') != '0') {
                                $('.tab2 .nav_in a').hide();
                                $(this).prev().show();
                                $(this).show()
                                $(this).next().show();
                                $(this).next().next().show();
                            }
                        });
                        $('.tab1 .prev-pagination').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            if ($('.tab1 .nav_in .active').attr('rel') != '0') {
                                $('.tab1 .nav_in .active').prev().addClass('active');
                                $('.tab1 .nav_in .active').next().removeClass('active');
                                $('.tab1 .nav_in a').hide();
                                $('.tab1 .nav_in .active').prev().show();
                                $('.tab1 .nav_in .active').show()
                                $('.tab1 .nav_in .active').next().show();
                                $('.tab1 .nav_in .active').next().next().next().show();
                                let currentPage = $('.tab1 .nav_in .active').attr('rel');
                                $('.tab1 .nav_in a').eq(currentPage).click();
                            }
                            if ($('.tab1 .nav_in .active').attr('rel') == '0') {
                                $('.tab1 .nav_in a').hide();
                                $('.tab1 .nav_in .active').show()
                                $('.tab1 .nav_in .active').next().show();
                                $('.tab1 .nav_in .active').next().next().show();
                                $('.tab1 .nav_in .active').next().next().next().show();
                            }
                        });
                        $('.tab2 .prev-pagination').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            if ($('.tab2 .nav_in .active').attr('rel') != '0') {
                                $('.tab2 .nav_in .active').prev().addClass('active');
                                $('.tab2 .nav_in .active').next().removeClass('active');
                                $('.tab2 .nav_in a').hide();
                                $('.tab2 .nav_in .active').prev().show();
                                $('.tab2 .nav_in .active').show()
                                $('.tab2 .nav_in .active').next().show();
                                $('.tab2 .nav_in .active').next().next().next().show();
                                let currentPage = $('.tab2 .nav_in .active').attr('rel');
                                $('.tab2 .nav_in a').eq(currentPage).click();
                            }
                            if ($('.tab2 .nav_in .active').attr('rel') == '0') {
                                $('.tab2 .nav_in a').hide();
                                $('.tab2 .nav_in .active').show()
                                $('.tab2 .nav_in .active').next().show();
                                $('.tab2 .nav_in .active').next().next().show();
                                $('.tab2 .nav_in .active').next().next().next().show();
                            }
                        });
                        $('.tab1 .next-pagination').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab1 .nav_in .active').next().addClass('active');
                            $('.tab1 .nav_in .active').prev().removeClass('active');
                            $('.tab1 .nav_in a').hide();
                            $('.tab1 .nav_in .active').prev().show();
                            $('.tab1 .nav_in .active').show()
                            $('.tab1 .nav_in .active').next().show();
                            $('.tab1 .nav_in .active').next().next().show();
                            let currentPage = $('.tab1 .nav_in .active').attr('rel');
                            $('.tab1 .nav_in a').eq(currentPage).click();
                        });
                        $('.tab2 .next-pagination').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab2 .nav_in .active').next().addClass('active');
                            $('.tab2 .nav_in .active').prev().removeClass('active');
                            $('.tab2 .nav_in a').hide();
                            $('.tab2 .nav_in .active').prev().show();
                            $('.tab2 .nav_in .active').show()
                            $('.tab2 .nav_in .active').next().show();
                            $('.tab2 .nav_in .active').next().next().show();
                            let currentPage = $('.tab2 .nav_in .active').attr('rel');
                            $('.tab2 .nav_in a').eq(currentPage).click();
                        });
                        $('.tab1 .first_row').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab1 .nav_in a').eq(0).click();
                            $('.tab1  .nav_in a').hide().removeClass('active');
                            $('.tab1 .nav_in a:first-child').addClass('active').show();
                            $('.tab1 .nav_in .active').next().show();
                            $('.tab1 .nav_in .active').next().next().show();
                            $('.tab1 .nav_in .active').next().next().next().show();
                        });
                        $('.tab1 .last_row').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab1 .nav_in a:last-child').click();
                            $('.tab1 .nav_in a').hide().removeClass('active');
                            $('.tab1 .nav_in a:last-child').addClass('active').show();
                            $('.tab1 .nav_in .active').prev().show();
                            $('.tab1 .nav_in .active').prev().prev().show();
                            $('.tab1 .nav_in .active').prev().prev().prev().show();
                        });
                        $('.tab2 .first_row').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab2 .nav_in a').eq(0).click();
                            $('.tab2 .nav_in a').hide().removeClass('active');
                            $('.tab2 .nav_in a:first-child').addClass('active').show();
                            $('.tab2 .nav_in .active').next().show();
                            $('.tab2 .nav_in .active').next().next().show();
                            $('.tab2 .nav_in .active').next().next().next().show();
                        });
                        $('.tab2 .last_row').click(function () {
                            setTimeout(function () {
                                // add class on scroll condition
                                (function ($) {
                                    $.fn.hasScrollBar = function () {
                                        return this.get(0).scrollHeight > this.height();
                                    }
                                })($);
                                if ($('.max-height').hasScrollBar()) {
                                    $('.table-container').addClass('active-scroll');
                                } else {
                                    $('.table-container').removeClass('active-scroll');
                                }
                            }, 2000);
                            $('.tab2 .nav_in a:last-child').click();
                            $('.tab2 .nav_in a').hide().removeClass('active');
                            $('.tab2 .nav_in a:last-child').addClass('active').show();
                            $('.tab2 .nav_in .active').prev().show();
                            $('.tab2 .nav_in .active').prev().prev().show();
                            $('.tab2 .nav_in .active').prev().prev().prev().show();
                        });
                        $('.tab1 select').change(function () {
                            var getpage = $(this).val() - 1;
                            $('.tab1 .nav_in a').eq(getpage).click();
                        });
                        $('.tab2 select').change(function () {
                            var getpage = $(this).val() - 1;
                            $('.tab2 .nav_in a').eq(getpage).click();
                        });
                    }
                    else {
                        this.setState({ ActiveJson: [], InActiveJson: [], iscalled: true });
                    }
                });
        }
        catch (error) {
        }
    }
    componentDidMount() {
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
        this.GetRepsDetailwithoutAPI();
        //setTimeout(function () {
        //    $('.pagination li:first-child').text('First');
        //    $('.pagination li:last-child').text('Last');

        //    // add class on scroll condition
        //    (function ($) {
        //        $.fn.hasScrollBar = function () {
        //            return this.get(0).scrollHeight > this.height();
        //        }
        //    })($);
        //    if ($('.max-height').hasScrollBar()) {
        //        $('.table-container').addClass('active-scroll');
        //    }
        //}, 2000);
    }
    ExportReps(e) {
        try {
            let Origin_Location = window.location.protocol + "//" + window.location.host;
            window.open(
                Origin_Location + '/report/exportreps1?&objectuid=' + this.state.userdata.id,
                '_blank'
            );
            e.preventDefault();
        }
        catch (error) { }
    }
    
    render() {
        let len = 0;
        try {
            len = this.state.ActiveJson.length + this.state.InActiveJson.length;
        }
        catch (error)
        {
            len = 0;
        }
        if (len > 0) {
            return (
                <div className='popup mfp-zoom-in'>
                    <div className='popup_inner rep'>
                        <div className='popup_scroll'>

                            <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>

                            <div className="tab-section">
                                <a href="javascript:void('0')" className="rep-download custom-tooltip"><img onClick={this.ExportReps}  src={exportIcon} className="export_icon" alt="Download Icon" /><span className="hover-tooltip">Download report</span></a>

                                <div className="tab">
                                    <a href="javascript:;" className="tab-link link1 active" onClick={this.handletab} data-id="1">Active</a>
                                    <a href="javascript:;" className="tab-link link2" onClick={this.handletab} data-id="12">Inactive</a>
                                </div>
                                <div className="tab1">

                                    <h3>Total Active Reps : {this.state.ActiveJson.length}</h3>

                                    <span>Reps with greater than 1 claim in last 30 days</span>

                                    <div className="table-container">
                                        {
                                            this.state.ActiveJson.length > 0 && this.state.ActiveJson != null ?
                                                <div>
                                                    <div className="flex-table header">
                                                        <div className="flex-row first">Name</div>
                                                        <div className="flex-row second">E-mail</div>
                                                        <div className="flex-row third">Assigned Group</div>
                                                        <div className="flex-row fourth">Commission</div>
                                                    </div>
                                                    <div className="table_body" id="inactive_reps">
                                                        <div className="max-height">
                                                            {
                                                                    this.state.ActiveJson.map((item, index) => {
                                                                        return <div className="flex-table" key={"Active" + index} ><div className="flex-row first">{item.SubDisName}</div><div className="flex-row second">{item.SubDisEmail}</div>
                                                                            <div className="flex-row third">
                                                                                {
                                                                                    item.GroupList.map((gpitem, _index) => {
                                                                                        return <div key={"ActiveGroup" + _index} >{gpitem.Group.split(' ')[0]}</div>
                                                                                    })
                                                                                }
                                                                            </div>

                                                                            <div className="flex-row fourth">
                                                                                {
                                                                                    item.GroupList.map((gpitem, _index) => {
                                                                                        return <div key={"sdbsbdsbGroup" + _index} >{gpitem.Group.split('(')[1].replace(')', '')}</div>
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    }) 
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="pagination">
                                                        { /*
                                                <div className="selectbox">
                                                    Jump to
                                                <select></select>
                                                </div>
                                                */}
                                                        <a href="javascript:;" className="first_row">First</a>
                                                        <a className="prev-pagination" href="javascript:;"></a>
                                                        <div className="nav_in">
                                                        </div>
                                                        <a className="next-pagination" href="javascript:;"></a>
                                                        <a href="javascript:;" className="last_row">Last</a>
                                                    </div>
                                                </div>
                                                : <span className="reps-not-found">{this.state.noDataDisplay}</span>
                                        }
                                    </div>

                                </div>
                                <div className="tab2">

                                    <h3>Total InActive Reps : {this.state.InActiveJson.length}</h3>

                                    <span>Reps with less than 1 claim in last 30 days</span>

                                    <div className="table-container">
                                        {
                                            this.state.InActiveJson.length > 0 && this.state.InActiveJson != null ?
                                                <div> 
                                                    <div className="flex-table header">
                                                        <div className="flex-row first">Name</div>
                                                        <div className="flex-row second">E-mail</div>
                                                        <div className="flex-row third">Assigned Group</div>
                                                        <div className="flex-row fourth">Commission</div>
                                                    </div>
                                                    <div className="table_body" id="inactive_reps2">
                                                        <div className="max-height">
                                                            {
                                                                this.state.InActiveJson.map((item, index) => {
                                                                    return <div className="flex-table" key={"Active" + index} ><div className="flex-row first">{item.SubDisName}</div><div className="flex-row second">{item.SubDisEmail}</div>
                                                                        <div className="flex-row third">
                                                                            {
                                                                                item.GroupList.map((gpitem, _index) => {
                                                                                    return <div key={"ActiveGroup" + _index} >{gpitem.Group.split(' ')[0]}</div>
                                                                                })
                                                                            }
                                                                        </div>

                                                                        <div className="flex-row fourth">
                                                                            {
                                                                                item.GroupList.map((gpitem, _index) => {
                                                                                    return <div key={"sdbsbdsbGroup" + _index} >{gpitem.Group.split('(')[1].replace(')', '')}</div>
                                                                                })
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="pagination2">
                                                        { /*
                                                <div className="selectbox">
                                                    Jump to
                                                <select></select>
                                                </div>
                                                */}
                                                        <a href="javascript:;" className="first_row">First</a>
                                                        <a className="prev-pagination" href="javascript:;"></a>
                                                        <div className="nav_in">
                                                        </div>
                                                        <a className="next-pagination" href="javascript:;"></a>
                                                        <a href="javascript:;" className="last_row">Last</a>
                                                    </div>
                                                </div>
                                                : <span className="reps-not-found">{this.state.noDataDisplay}</span>
                                            }
                                    </div>

                                </div>
                            </div>
                            { this.state.error &&
                                <div className={'alert alert-danger tab-alert'}>{this.state.error}</div>
                            }
                        </div>
                    </div>
                </div>
            );
        }
        else {
            if (this.state.APICalled == false) {
                return (
                    <div className='popup mfp-zoom-in activeInactiveReps'>
                        <div className='popup_inner rep'>
                            <div className='popup_scroll'>

                                <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>


                                <div className="WhCommission">
                                    <div className="theme-loader repLoader"></div>
                                    <div className="tab-section please-wait"><h3>Please wait...</h3></div>
                                </div>

                            </div>
                        </div>
                    </div>
                );
            }
            else {

                return (
                    <div className='popup mfp-zoom-in activeInactiveReps'>
                        <div className='popup_inner rep'>
                            <div className='popup_scroll'>

                                <h1>{this.state.header}<button onClick={this.props.closePopup}>X</button></h1>

                                <div className="tab1">

                                    <span className="no-row-found">No Reps Found</span>
                                </div>

                            </div>
                        </div>
                    </div>
                );
            }
        }
    }
}

export default ReportPopup;